<template>
  <div id="userManual" v-click-outside="hide">
    <div @click="show = true">
      <img src="../../assets/img/UserManual.png" />
    </div>
    <div :class="['dropdownUser', { show: show }]" @mouseleave="show = false">
      <div class="box">
        <div class="list" v-for="(option, index) in optionList" :key="index">
          <a :href="option.link" target="_blank">
            <div :class="['option']"><i :class="option.icon"></i>{{ $t(option.name) }}</div></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  private show = false;
  private optionList = [
    {
      name: "ManualPEAKTax",
      icon: "far fa-file-alt",
      link: "https://www.peakaccount.com/peak-manual/peak-tax",
    },
    {
      name: "VideoUserManual",
      icon: "fas fa-play",
      link: "https://www.youtube.com/watch?v=1uP8yscDETY&list=PLKx_LgGwE9YNaQBACHUHcDEpg3APZMNyS&index=1",
    },
  ];

  public hide() {
    this.show = false;
  }
}
</script>

<style lang="scss" scoped>
#userManual {
  img {
    width: 18px;
    margin-top: -9px;
    margin-left: 10px;
    cursor: pointer;
  }
  .dropdownUser {
    position: absolute;
    top: 63px;
    margin-left: -161px;
    width: max-content;
    border-radius: 6px;
    overflow: hidden;
    background: rgb(255, 255, 255);
    z-index: 99;
    max-height: 0px;
    @include shadowboxLv2;
    transition: 0.5s;
    .name {
      text-align: center;
      padding: 15px;
      cursor: pointer;
      transition: all 0.5s ease;
      &:hover {
        color: $purple_default;
      }
    }
    hr {
      margin-top: 0px;
      width: 80%;
    }
    a {
      color: unset;
    }
    .list {
      position: relative;
    }
    .option {
      position: relative;
      display: flex;
      align-items: center;
      padding: 10px 20px 10px 10px;
      cursor: pointer;
      transition: all 0.5s ease;

      i {
        font-size: 14px;
        width: 30px;
        text-align: center;
      }
      &:hover {
        color: $purple_default;
        background: $hover;
      }
    }
  }
  .show {
    max-height: 500px;
  }
}
</style>
